// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Axios from 'axios'
import VueI18n from 'vue-i18n'
import Croppa from 'vue-croppa'
import moment from 'moment'
import SocialSharing from 'vue-social-sharing'
import Tooltip from 'vue-directive-tooltip'
// Plugins CSS
import 'vue-croppa/dist/vue-croppa.css'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css'

import 'nouislider/dist/nouislider.min.css'
import * as noUiSlider from 'nouislider'
window.noUiSlider = noUiSlider

window.moment = moment
require('../static/js/plugin/datepicker/bootstrap-datetimepicker.min.js')

if (location.host === 'cms.indiefy.net') {
  // eslint-disable-next-line
  location.href = 'https://indiefy.net'
} else if (location.host === 'services.indiefy.net') {
  location.href = 'https://indiefy.net/services'
}

Vue.use(VueI18n)
Vue.use(Croppa)
Vue.use(SocialSharing)
Vue.use(Tooltip)

window.$user = Vue.prototype.$user = {}
Vue.prototype.$http = Axios
Vue.prototype.$http.defaults.withCredentials = true
window.$eventBus = Vue.prototype.$eventBus = new Vue()
Vue.prototype.$notify = function (data, type, icon) {
  if (icon) {
    icon = 'fa ' + icon
  }

  window.$.notify({ title: data.title, message: data.message, icon: icon }, {
    type: type || 'default',
    placement: {
      from: 'top',
      align: 'right'
    },
    time: 1000,
    delay: 5000
  })
}

Vue.config.productionTip = false

if (location.host.match(/localhost/)) {
  window.apiURL = 'http://localhost:3000/v1/'
} else if (location.host.match(/development\.indiefy|cms-development/)) {
  window.apiURL = 'https://development.indiefy.net/v1/'
} else {
  window.apiURL = '/v1/'
  window.smartlook && window.smartlook('init', 'bbe6fd82b8c90d5a6eaaab8bd28415492c6d0ca5', { region: 'eu' })
  // window.atatus && atatus.config('9a767b00333543efa4de45822127e5af').install()
  // trackVueExceptions()
}

let lang = window.navigator.userLanguage || window.navigator.language.split('_')[0]
lang = lang.split('-')[0]
console.log('Browser language:', lang)

if (localStorage.getItem('defaultLang')) {
  lang = localStorage.getItem('defaultLang')
}

function getSearchParam (name, url) {
  if (!url) url = window.location.href
  name = name.replace(/[[]]/g, '\\$&')
  let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
  let results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

if (window.location.pathname.match(/digital-gratuita/)) {
  lang = 'es'
}

if (window.location.search.includes('lang=')) {
  lang = getSearchParam('lang')
  window.appLang = lang
}

if (!['ar', 'de', 'en', 'es', 'hi', 'it', 'ko', 'pt', 'ru', 'tr', 'zh', 'ja', 'fr', 'ca'].includes(lang)) {
  lang = 'en'
  window.appLang = 'en'
}

if (window.location.search.includes('access_token')) {
  window.accessToken = getSearchParam('access_token')

  Axios.interceptors.request.use((config) => {
    config.params = { ...config.params, accessToken: window.accessToken }

    return config
  }, function (error) { console.log(error) })
}

const i18n = Vue.prototype.i18n = new VueI18n({
  locale: lang,
  fallbackLocale: 'en'
})

if (lang === 'es') {
  /* eslint-disable */
  (function(w){
    var k="nudgify",n=w[k]||(w[k]={});
    n.uuid="3f89ec81-d755-4ccd-8a10-bc71529bed60";
    var d=document,s=d.createElement("script");
    s.src="https://pixel.nudgify.com/pixel.js";
    s.async=1;
    s.charset="utf-8";
    d.getElementsByTagName("head")[0].appendChild(s)
  })(window);
  /* eslint-enable */
}

import(`../static/langs/${lang}.json`).then(msgs => {
  i18n.setLocaleMessage(lang, msgs)
  i18n.locale = lang

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    i18n,
    components: { App },
    template: '<App/>'
  })
})



// WEBPACK FOOTER //
// ./src/main.js